import React from "react"

import { DeleteProjectOverlayView } from "./DeleteProjectOverlayView"
import { useDeleteProjectOverlayViewModel } from "./hooks/useDeleteProjectOverlayViewModel"

export interface DeleteProjectOverlayPayload {
  projectID: string
}

export interface DeleteProductPositionsOverlayProps {
  payload: DeleteProjectOverlayPayload
}

export const DeleteProjectOverlay = React.memo(
  ({ payload: { projectID } }: DeleteProductPositionsOverlayProps) => (
    <DeleteProjectOverlayView
      {...useDeleteProjectOverlayViewModel(projectID)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    DELETE_PROJECT_OVERLAY: DeleteProjectOverlayPayload
  }
}
